import React from 'react';
import PropTypes from 'prop-types';

import { strings } from 'APP_ROOT/localization';
import EditableLabel from 'APP_ROOT/components/EditableLabel';

export default class Name extends React.Component {

    static propTypes = {
        value: PropTypes.string.isRequired,
        pending: PropTypes.bool,
        maxLength: PropTypes.number.isRequired,
    }

    state = {
        editing: false
    }

    componentDidUpdate(prevProps) {
        // If selection changes while editing, we discard the edit
        if(prevProps.geofenceId !== this.props.geofenceId && this.state.editing) {
            this.cancelEditing();
        }
    }

    save = (value) => {
        this.props.onChange(value);
        this.setState({
            editing: false
        });
    }

    cancelEditing = () => {
        this.setState({
            editing: false
        });
    }

    startEditing = () => {
        this.setState({
            editing: true
        });
    }

    render () {

        const {
            value,
            pending,
            maxLength,
            editable
        } = this.props;

        return (
            <section className="geofence-name">
                <h4 className="label">{strings.resource_name}</h4>
                <EditableLabel
                    value={value}
                    editing={this.state.editing}
                    loading={pending}
                    onRequestEdit={this.startEditing}
                    onChange={this.save}
                    onCancel={this.cancelEditing}
                    maxLength={maxLength}
                    canEdit={editable}
                />
            </section>
        )
    }
}
